module.exports = __webpack_public_path__ + "static/media/attachment-from-computer.7cbd96b8.svg";